/**
 * Cost View Action Types
 *
 * @author slak4170
 */

export const REQUEST_COST_VIEW_DATA = 'REQUEST_COST_VIEW_DATA';
export const RECEIVE_COST_VIEW_DATA = 'RECEIVE_COST_VIEW_DATA';

export const REQUEST_COST_VIEW_DETAILED_DATA = 'REQUEST_COST_VIEW_DETAILED_DATA';
export const RECEIVE_COST_VIEW_DETAILED_DATA = 'RECEIVE_COST_VIEW_DETAILED_DATA';

export const RESET_COST_VIEW_DATA = 'RESET_COST_VIEW_DATA';

export const requestCostViewData = (data) => ({ type: REQUEST_COST_VIEW_DATA, data });
export const receiveCostViewData = (data) => ({ type: RECEIVE_COST_VIEW_DATA, data });

export const requestCostViewDetailedData = (data) => ({ type: REQUEST_COST_VIEW_DETAILED_DATA, data });
export const receiveCostViewDetailedData = (data) => ({ type: RECEIVE_COST_VIEW_DETAILED_DATA, data });

export const resetCostViewData = () => ({ type: RESET_COST_VIEW_DATA });
